export const EDITABLE_HOVER_CLASSES = 'group relative hover:before:absolute hover:before:inset-0 hover:before:border-4 hover:before:border-blue-600 cursor-pointer';
// export const EDITABLE_HOVER_CLASSES = 'group hover:outline hover:outline-4 hover:outline-blue-600 hover:outline-offset-4 cursor-pointer';

export const DEFAULT_ANIMATION = {
  type: 'slideUp',
  duration: 1000,
  delay: 100
} as const;